/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { EDIT_SOFTSKILL_ABILITY } from "./actionTypes"
import {
  editSoftskillAbilityError,
  editSoftskillAbilitySuccess,
} from "./actions"

//Include Both Helper File with needed methods
import { updateSoftskillsAbility } from "../../../helpers/backend_helper"

function* edit(action) {
  try {
    const response = yield call(updateSoftskillsAbility, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.abilityId) throw new Error("Error al guardar la habilidad")
    yield put(editSoftskillAbilitySuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(editSoftskillAbilityError(error.message))
  }
}

function* softskillAbilityEditSaga() {
  yield takeEvery(EDIT_SOFTSKILL_ABILITY, edit)
}

export default softskillAbilityEditSaga
